import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { DContext } from '../../../context/Datacontext';
import { fetchSessionLogsApi } from '../../services/fetchSessionLogsApi';
import LogsNavigator from './LogsNavigator';


export const SessionLogs = () => {
    const { BeURL } = useContext(DContext)
    const [sessionLogs, setSessionLogs] = useState(null);

    const [currentPage, setCurrentPage] = useState(1)
    // const rowsPerPage = 15
    const [rowsPerPage, setRowsPerpage] = useState(10)
    const [totalPage, setTotalPage] = useState(0)
    const [totalSessionLogs, setTotlaSessionLogs] = useState(0)
    const navigate = useNavigate()

    const handleUserHistory = (userId) => {
        navigate(`/fetch-log-history/${userId}`)
    }

    useEffect(() => {
        if(currentPage <= totalPage || totalPage === 0) {
            fetchSessionLogsApi(BeURL, setSessionLogs, currentPage, rowsPerPage, setTotlaSessionLogs, setTotalPage)
        }
        else {
            setCurrentPage(1)
        }
    }, [currentPage, rowsPerPage, BeURL]);

    useEffect(() => {
        setCurrentPage(1)
    }, [rowsPerPage])

    const handlePagination = (dir) => {
        if (dir === 'prev' && currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
        if (dir === 'next' && currentPage < totalPage) {
            setCurrentPage(prev => prev + 1);
        }
    };
    return (
        <div className="min-h-[75vh] p-4">
            <LogsNavigator />
            {/* Heading */}
            <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-3">
                <h2 className="text-2xl font-bold text-primary-500">
                    User History
                </h2>
            </div>
            <div className="overflow-auto min-h-[55vh] bg-white rounded-xl shadow-md">
                {/* Header */}
                <table className="w-full text-left border-collapse">
                    <thead className=" bg-primary-500 text-white">
                        <tr className='min-w-full'>
                            <td className='py-3 px-2'>Name</td>
                            <td className='py-3 px-2'>Status</td>
                            <td className='py-3 px-2'>Clock In</td>
                            <td className='py-3 px-2'>Clock Out</td>
                            <td className='py-3 px-2'>Action</td>
                        </tr>
                    </thead>
                    <tbody className=' '>
                        {sessionLogs && sessionLogs.length > 0 ? (
                            sessionLogs.map((user, index) => (
                                <tr
                                    key={index}
                                    className="min-w-full border-b-[0.1px] hover:bg-blue-50 border-b-gray-100"
                                >
                                    <td className='p-2 cursor-pointer font-medium text-primary-200' onClick={() => window.open(`/user/${user._id}`)}>{user?.fullName || ""}</td>
                                    <td className={`py-2 ${user?.lastStatus === "in" ? "text-green-600" : "text-red-600"}`}>
                                        {user?.lastStatus || "-"}
                                    </td>
                                    <td className='p-2'>
                                        {user.lastLogin
                                            ? new Date(user?.lastLogin).toLocaleDateString([], { day: '2-digit', month: '2-digit', year: 'numeric' })
                                            : '-'}
                                        <td className='p-2 text-xs text-gray-500 font-bold'>
                                            {new Date(user?.lastLogin).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })}</td>
                                    </td>
                                    <td className='p-2'>
                                        {user.lastLogout
                                            ? new Date(user?.lastLogout).toLocaleDateString([], { day: '2-digit', month: '2-digit', year: 'numeric' })
                                            : '-'}
                                        <td className='text-xs  text-secondary-400 font-bold'>{user?.lastStatus === "out" ? new Date(user?.lastLogout).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }) : '-'}</td>
                                    </td>
                                    <td className='p-2'>
                                        <button
                                            onClick={() => handleUserHistory(user?.id)}
                                            onTouchStart={() => handleUserHistory(user?.id)}
                                            type="button"
                                            className="px-2 py-1 bg-gradient-to-r from-primary-100 to-secondary-100 text-white text-sm rounded-lg shadow-md hover:from-primary-300 hover:to-secondary-300 transition"
                                        >
                                            History
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <div className="flex justify-center items-center h-48">
                                <td className="text-gray-500">No session logs available.</td>
                            </div>
                        )
                        }
                    </tbody>
                </table>
            </div>
            <div>
                {/* Pagination Controls */}
                <div className=" mx-auto mt-3 flex justify-around items-center">
                    <div className="flex items-center gap-2">
                        <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
                        <select
                            id="recordsPerPage"
                            value={rowsPerPage}
                            onChange={e => setRowsPerpage(parseInt(e.target.value, 10))}
                            className="ml-2 px-3 py-1 border rounded"
                        >
                            {[10, 20, 25, 50, 75, 100].map(n => (
                                <option key={n} value={n}>{n}</option>
                            ))}
                        </select>
                    </div>
                    <div className="text-sm">Total Session Logs: {totalSessionLogs}</div>
                </div>
                <div className="flex justify-center items-center gap-4">
                    <span className={`td-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => handlePagination('prev')}
                        disabled={currentPage === 1}
                    >
                        chevron_left
                    </span>
                    <span>{currentPage} of {totalPage}</span>
                    <span className={`td-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === totalPage ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => handlePagination('next')}
                        disabled={currentPage === totalPage}
                    >
                        chevron_right
                    </span>
                </div>
            </div>
        </div>
    )
}
